"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useState, useEffect } from "react";
import { cartInitialState, getInitialCartState } from "../BrowseContext/defaultState.js";
import { cartCount } from "../BrowseContext/legacyCookieStorage.js";
const COMPONENT_NAME = "CartContextProvider";
const CartContext = createContext(null);
const CartContextProvider = ({ children }) => {
  const [cartState, setCartState] = useState(cartInitialState);
  const addToCart = (orderItem) => {
    const updatedOrderItems = [...cartState.orderItems, orderItem];
    const cartItemCount = updatedOrderItems.length;
    cartCount.write(cartItemCount);
    setCartState({
      ...cartState,
      cartItemCount,
      orderItems: updatedOrderItems
    });
  };
  const removeFromCart = (itemNumber) => {
    const updatedOrderItems = cartState.orderItems.filter(
      (item) => item.itemNumber !== itemNumber
    );
    const cartItemCount = updatedOrderItems.length;
    cartCount.write(cartItemCount);
    setCartState({
      ...cartState,
      cartItemCount,
      orderItems: updatedOrderItems
    });
  };
  const refreshCart = () => {
    const cartItemCount = cartCount.read();
    setCartState({
      ...cartState,
      cartItemCount
    });
  };
  useEffect(() => {
    if (typeof window !== "undefined") {
      setCartState(getInitialCartState());
    }
  }, [typeof window]);
  const context = {
    ...cartState,
    addToCart,
    refreshCart,
    removeFromCart
  };
  return /* @__PURE__ */ jsx(CartContext.Provider, { value: context, children });
};
CartContextProvider.displayName = COMPONENT_NAME;
export {
  CartContext,
  CartContextProvider
};
